import React from 'react';
import { AlertCircle } from 'lucide-react';

interface EmptyStateProps {
    title: string;
    message: string;
}

export default function EmptyState({ title, message }: EmptyStateProps) {
    return (
        <div className="text-center py-12 bg-white rounded-lg shadow-sm border border-gray-200">
            <div className="mx-auto h-12 w-12 text-gray-400 mb-4">
                <AlertCircle size={48} />
            </div>
            <h3 className="text-lg font-medium text-gray-900">{title}</h3>
            <p className="text-gray-500 mt-2">{message}</p>
        </div>
    );
}
